export const getLocaleStorage = (key: string, prop?: string) => {
  const info = JSON.parse(localStorage.getItem(key) || '{}')
  if (prop) {
    return info[prop]
  }
  return info
}

export const setLocaleStorage = (key: string, prop: any, value?: any) => {
  let info = JSON.parse(localStorage.getItem(key) || '{}')
  if (value !== undefined) {
    info[prop.toString()] = value
  } else {
    info = { ...info, ...prop }
  }
  localStorage.setItem(key, JSON.stringify(info))
}

export const removeLocaleStorage = (key: string) => {
  localStorage.removeItem(key)
}
